var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.tables),function(tableKey,index){return _c('Table',{key:index,staticClass:"mb-4",attrs:{"fields":_vm.fields,"items":_vm.doItems(_vm.data, tableKey)}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }